import {
  AGENTIC_LOGIC_SURFACE_LABEL,
  type AgenticLogicSurface,
  AgenticLogicSurfaceList,
} from "@intelligems/ig-types/dtos/agentic-logic/surface";

/**
 * Merchant-facing names for the serving surfaces.
 *
 * A re-export, not a copy. The labels moved into ig-types when the evaluation
 * budget's disclosure sentence began being composed there and rendered on both
 * sides of the wire; keeping a second map here is exactly the drift this file
 * was written to prevent.
 */
export const SURFACE_LABEL: Record<AgenticLogicSurface, string> =
  AGENTIC_LOGIC_SURFACE_LABEL;

/**
 * Surfaces the UI does not offer yet. Empty today; keep the mechanism so a
 * surface can ship in the DTOs and backend contract before its UI is ready.
 */
const HIDDEN_SURFACES: ReadonlySet<AgenticLogicSurface> = new Set();

/** Surfaces the UI offers for selection and filtering. */
export const VISIBLE_SURFACES: readonly AgenticLogicSurface[] =
  AgenticLogicSurfaceList.filter((surface) => !HIDDEN_SURFACES.has(surface));

/** Drops hidden surfaces from a list before it is shown to the merchant. */
export const visibleSurfaces = (
  surfaces: readonly AgenticLogicSurface[]
): AgenticLogicSurface[] =>
  surfaces.filter((surface) => !HIDDEN_SURFACES.has(surface));
